(function () {
  var MIN_CHARS = 2;
  var SECTION_ID = 'predictive-search';
  var DEBOUNCE = 250;

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function setup(wrapper) {
    var form = wrapper.querySelector('form');
    var input = wrapper.querySelector('input[name="q"]');
    var box = wrapper.querySelector('[data-predictive]');
    if (!form || !input || !box) return;

    var controller = null;

    function hide() {
      box.hidden = true;
      wrapper.removeAttribute('data-open');
    }

    function show() {
      box.hidden = false;
      wrapper.setAttribute('data-open', '');
    }

    function buildUrl(q) {
      var url = new URL(form.getAttribute('action'), window.location.origin);
      url.searchParams.set('q', q);
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      url.searchParams.set('section_id', SECTION_ID);
      return url.toString();
    }

    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < MIN_CHARS) {
        hide();
        return;
      }
      if (controller) controller.abort();
      controller = new AbortController();
      fetch(buildUrl(q), { signal: controller.signal })
        .then(function (res) {
          return res.ok ? res.text() : '';
        })
        .then(function (html) {
          if (!html) {
            hide();
            return;
          }
          box.innerHTML = html;
          show();
        })
        .catch(function () {
          /* aborted oder Netzwerkfehler – stillschweigend ignorieren */
        });
    }, DEBOUNCE);

    input.addEventListener('input', run);

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_CHARS && box.innerHTML.trim()) show();
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        hide();
        input.blur();
        return;
      }

      if (box.hidden) return;
      var items = box.querySelectorAll('.predictive__item, .predictive__all');
      if (!items.length) return;

      var current = box.querySelector('.is-active');
      var idx = Array.prototype.indexOf.call(items, current);

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        idx = (idx + 1) % items.length;
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        idx = (idx - 1 + items.length) % items.length;
      } else if (event.key === 'Enter') {
        if (current) {
          event.preventDefault();
          current.click();
        }
        return;
      } else {
        return;
      }

      items.forEach(function (el) {
        el.classList.remove('is-active');
      });
      items[idx].classList.add('is-active');
      items[idx].scrollIntoView({ block: 'nearest' });
    });

    document.addEventListener('click', function (event) {
      if (!wrapper.contains(event.target)) hide();
    });
  }

  function init() {
    document.querySelectorAll('[data-predictive-search]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
